export default __webpack_public_path__ + "static/media/IcOn.19f49f52.svg";